/**
 * Same-tick skill hit deferral — apply after ally motion so T0 dodge travel
 * counts on the resolve frame (no tick-order swap of AI vs skill windup).
 */
type DeferredHit = () => void;

let queue: DeferredHit[] = [];

export function deferRaidSkillHit(fn: DeferredHit): void {
  queue.push(fn);
}

export function flushRaidDeferredSkillHits(): void {
  if (queue.length === 0) return;
  const batch = queue;
  queue = [];
  for (const fn of batch) fn();
}

/** Test / safety: drop pending without applying. */
export function clearRaidDeferredSkillHits(): void {
  queue = [];
}
